module.exports = __webpack_public_path__ + "media/images/app/testimonials/star-black-af15978ea2cb6e227f59949559b5780c.svg";